import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch {
      toast.error("Bir hata oluştu, tekrar dene");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-slate-50 to-sky-50 flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        <Link to="/giris" className="flex items-center gap-1 text-sm text-slate-500 hover:text-indigo-600 font-semibold mb-4">
          <ArrowLeft className="w-4 h-4" /> Girişe dön
        </Link>
        <div className="bg-white rounded-3xl shadow-xl p-8">
          {sent ? (
            <div className="text-center" data-testid="forgot-sent">
              <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto" />
              <h1 className="font-display text-2xl font-bold text-slate-900 mt-3">E-postanı kontrol et 📧</h1>
              <p className="text-slate-500 mt-2 text-sm">Eğer bu e-posta kayıtlıysa, şifre sıfırlama bağlantısını gönderdik. Bağlantı 1 saat geçerli.</p>
              <Link to="/giris"><Button className="mt-6 rounded-xl font-bold bg-indigo-600 hover:bg-indigo-700">Giriş sayfasına git</Button></Link>
            </div>
          ) : (
            <>
              <div className="text-center mb-6">
                <div className="text-4xl">🔑</div>
                <h1 className="font-display text-2xl font-bold text-slate-900 mt-2">Şifreni mi unuttun?</h1>
                <p className="text-slate-500 text-sm mt-1">Kayıtlı e-postanı gir, sana sıfırlama bağlantısı gönderelim.</p>
              </div>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <Label className="text-sm font-semibold">E-posta</Label>
                  <div className="relative mt-1">
                    <Mail className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
                    <Input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ornek@eposta.com" className="rounded-xl pl-9" />
                  </div>
                </div>
                <Button data-testid="forgot-submit-btn" type="submit" disabled={busy} className="w-full bg-indigo-600 hover:bg-indigo-700 rounded-xl py-6 font-bold">
                  {busy ? "Gönderiliyor..." : "Sıfırlama Bağlantısı Gönder"}
                </Button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
